import { createStyles } from '@mantine/styles';

export default createStyles((theme) => ({
  input: {
    paddingTop: theme.spacing.xs,
    paddingBottom: theme.spacing.xs,
  },
}));
